import { render, staticRenderFns } from "./batchAddCard.vue?vue&type=template&id=22c20470&scoped=true&"
import script from "./batchAddCard.vue?vue&type=script&lang=js&"
export * from "./batchAddCard.vue?vue&type=script&lang=js&"
import style0 from "./batchAddCard.vue?vue&type=style&index=0&id=22c20470&prod&scoped=true&lang=css&"
import style1 from "./batchAddCard.vue?vue&type=style&index=1&id=22c20470&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c20470",
  null
  
)

export default component.exports